import api from 'Cloud/Application/api';
import { getErrorMsg, logger } from 'lib/logger';
import { QuotaAPICall } from 'reactApp/api/QuotaAPICall';
import { IS_BLOCKED, IS_REACT_PAGE } from 'reactApp/appHelpers/configHelpers';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { loadUserQuotaRequest, loadUserQuotaSuccess } from 'reactApp/modules/userQuota/userQuota.module';
import { noop } from 'reactApp/utils/helpers';
import { call, cancel, put, select, takeEvery } from 'redux-saga/effects';

const callApi = () => new QuotaAPICall().makeRequest();

type AnonymousSelector = ReturnType<typeof UserSelectors.isAnonymous>;

type ApiCall = Awaited<ReturnType<typeof callApi>>;

export function* loadQuota() {
    try {
        const isAnonymous: AnonymousSelector = yield select(UserSelectors.isAnonymous);

        if (isAnonymous || IS_BLOCKED) {
            return;
        }

        if (IS_REACT_PAGE) {
            // Дергаем старую ручку квоты - на нее завязана аналитика DAU, потом сделают более лучший вариант.
            // timeout - чтобы не сильно мешать другим запросам и влиять на скорость отображения страницы
            setTimeout(() => api.user.space().done(noop), 2000);
        }

        const { data }: ApiCall = yield call(callApi);

        yield put(loadUserQuotaSuccess(data));
    } catch (error) {
        logger.error(getErrorMsg(error), error);
        yield cancel();
    }
}

export function* watchUserQuota() {
    yield takeEvery(loadUserQuotaRequest.toString(), loadQuota);
}
